export const USER_LOGIN_REQUEST = "LOGIN_USER/USER_LOGIN_REQUEST";
export const USER_LOGIN_SUCCESS = "LOGIN_USER/USER_LOGIN_SUCCESS";
export const USER_LOGIN_FAILURE = "LOGIN_USER/USER_LOGIN_FAILURE";
export const RESET_LOGIN_ERROR = "LOGIN_USER/RESET_LOGIN_ERROR";


// WEBPACK FOOTER //
// ./src/containers/Layouts/Default/Signin/constants.js